import {StrictMode} from 'react';
import {createRoot,hydrateRoot} from 'react-dom/client';
import './index.css';
import './refinements.css';
import App from './App';
import {startCatalogSync} from './lib/catalog';
const root=document.getElementById('root')!;
const canonical=document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
const renderedPath=canonical?new URL(canonical.href).pathname:null;
if(root.hasChildNodes()&&!window.location.search&&renderedPath===window.location.pathname)hydrateRoot(root,<StrictMode><App/></StrictMode>);
else createRoot(root).render(<StrictMode><App/></StrictMode>);
startCatalogSync();
